import { c as _c } from "react/compiler-runtime";
import { Divider, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { SelectedItemsBox } from './selectionPanel/selectedItemsBox';
import { SearchBar } from '../search/searchBar';
export const AddValuesPanel = t0 => {
  const $ = _c(25);
  const {
    entityName,
    addedValues,
    onAddClick,
    renderItem,
    itemKey,
    onRemove,
    clearAll
  } = t0;
  const [input, setInput] = useState("");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      marginTop: "12px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      padding: "12px 24px"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `Add one or more ${entityName}${entityName.endsWith("s") ? "es" : "s"}`;
  let t4;
  if ($[2] !== t3) {
    t4 = <Typography variant="body1" sx={t2}>{t3}</Typography>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Divider />;
    t6 = {
      gap: "12px",
      overflow: "hidden"
    };
    $[4] = t5;
    $[5] = t6;
  } else {
    t5 = $[4];
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      padding: "0 24px 12px"
    };
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== addedValues || $[8] !== entityName || $[9] !== input || $[10] !== onAddClick) {
    t8 = <Stack sx={t7}><SearchBar value={input} setValue={setInput} placeholder={entityName} selectedValues={addedValues} onAddClick={onAddClick} showAddButton={true} hideSearchIcon={true} /></Stack>;
    $[7] = addedValues;
    $[8] = entityName;
    $[9] = input;
    $[10] = onAddClick;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== addedValues || $[13] !== clearAll || $[14] !== entityName || $[15] !== itemKey || $[16] !== onRemove || $[17] !== renderItem) {
    t9 = addedValues.length > 0 && <SelectedItemsBox items={addedValues} entityType={entityName} renderItem={renderItem} itemKey={itemKey} onRemove={onRemove} clearAll={clearAll} />;
    $[12] = addedValues;
    $[13] = clearAll;
    $[14] = entityName;
    $[15] = itemKey;
    $[16] = onRemove;
    $[17] = renderItem;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t8 || $[20] !== t9) {
    t10 = <Stack divider={t5} sx={t6}>{t8}{t9}</Stack>;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t4) {
    t11 = <Stack className="max-h-[480px] overflow-hidden" sx={t1}>{t4}{t10}</Stack>;
    $[22] = t10;
    $[23] = t4;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
};